// Third party
import { ErrorPolicy } from '@apollo/client';

// Utils
import {
  GiftCardByIdQuery,
  GiftCardByIdDocument,
  GiftCardByIdQueryVariables,
} from '@gql';
import { createApolloClient } from '../apollo-node-client';

type Options = {
  variables: GiftCardByIdQueryVariables;
  errorPolicy?: ErrorPolicy;
};

export const imperativeNodeGiftCardByIdQuery = async (options: Options) => {
  const apolloClient = createApolloClient();

  const response = await apolloClient.query<GiftCardByIdQuery>({
    ...{ query: GiftCardByIdDocument },
    ...options,
  });

  return { ...response, apolloClient };
};
